export { default } from './Footer';
export * from './models';



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/Footer/index.ts